module.exports = __webpack_public_path__ + "static/HTSLogo2.536ae1ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HTSLogo2.svg
// module id = 133
// module chunks = 114276838955818